// Lottie animation paths - fetched at runtime by LottiePlayer, not bundled
// into JS (see app/shared/lottie-player.tsx for why).
const academicAnim = '/lottie/academic-brilliance-feature-animation.json';
const knowledgeAnim = '/lottie/knowledge-feature-animation.json';
const leadershipAnim = '/lottie/leadership-feature-animation.json';
const thinkingAnim = '/lottie/thinking-feature-animation.json';

export const features = [
  {
    title: 'Academic Brilliance Unleashed',
    description: 'Discover the world of Elite Scholars through their consistent high academic performance. Unravel the stories behind their mastery of subject matter and the journey that leads to exceptional achievements.',
    animation: academicAnim
  },
  {
    title: 'The Quest for Knowledge',
    description: 'Dive into the intellectual curiosity that fuels Elite Scholars. Explore their passion for learning beyond textbooks, their inquisitive minds, and their exploration of diverse fields of knowledge.',
    animation: knowledgeAnim
  },
  {
    title: 'Leadership That Inspires',
    description: 'Learn about the leadership skills that make Elite Scholars stand out. From taking initiative to inspiring others, Elite Scholars are often at the forefront of academic, extracurricular, and community activities.',
    animation: leadershipAnim
  },
  {
    title: 'Masters of Critical Thinking',
    description: 'Explore the critical thinking and problem-solving prowess that Elite Scholars bring to the table. From analytical skills to creative thinking, discover how they tackle complex problems with finesse.',
    animation: thinkingAnim
  }
];
